import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconInfoStyle0 = gravityIconIndividualCss;

const GravityIconInfo = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'c83704ad39b24441997fc8cd5f256ad9847a493c', color: this.color, size: this.size }, h("svg", { key: 'c9e782338754fb9ff71886f50c283f88232a82cd', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '367cdc3e08294f988f3e87649e5659292163cbe9', d: "M12.25 7.56a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-4 3.44v-.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4h-2a.5.5 0 0 1-.5-.5Z", fill: "currentColor" }), h("path", { key: '67fb759e7bc182d0668ed6e02271273fe91bf234', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 11a9 9 0 0 1 9-9 9.01 9.01 0 0 1 9 9 9 9 0 1 1-18 0Zm16.5 0a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0Z", fill: "currentColor" }))));
    }
};
GravityIconInfo.style = GravityIconInfoStyle0;

export { GravityIconInfo as gravity_icon_info };

//# sourceMappingURL=gravity-icon-info.entry.js.map